import * as dto from '@epicuro-next/data/baskets-dto';

export function getAttributeValues(
  product: dto.ReferencedProduct,
  attributeName: string,
): string[] {
  return product.attributes
    ? product.attributes[attributeName]?.filter((value) => value) ?? []
    : [];
}
